// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import UtilityProviderPage from '@/features/utility-providers/components/UtilityProviderPage';

export const Route = createFileRoute(
  '/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/',
)({
  component: () => <UtilityProviderPage utilityType="water" />,
});
